import * as types from "../../actions/systemlevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_DEDUCTION_AMOUNT_DEBIT_CARD_VALUES_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
